export default __webpack_public_path__ + "static/media/timeline.c7c1ece5.svg";